import DropdownFactory from 'common/components/legacy/Dropdown';

export default () => {
  new DropdownFactory(document.querySelector('#site-chrome-header'));
  new DropdownFactory(document.querySelector('#site-chrome-footer'));
};
